<template>
  <div class="my-approval tb">
    <custom-tab :list="tabData" v-model="tabIndex" :fixBorder="true"></custom-tab>
    <div class="container">
        <!-- 我发起的 -->
        <inititated v-if="`${tabIndex}` === '0'"></inititated>
        <!-- 待我审批 -->
        <wait-approval v-if="`${tabIndex}` === '1'"></wait-approval>
        <!-- 我已审批 -->
        <has-approval v-if="`${tabIndex}` === '2'"></has-approval>
        <!-- 抄送给我的 -->
        <cc-to-me v-if="`${tabIndex}` === '3'"></cc-to-me>
    </div>
  </div>
</template>

<script>
/** 我的审批 */
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import inititated from './children/approval_my_initiated';
import waitApproval from './children/approval_wait_approval';
import hasApproval from './children/approval_has_approval';
import ccToMe from './children/approval_cc_to_me';

export default {
  name: 'myApproval',
  mixins: [tableFilterValueMixins],
  components: {
    inititated,
    waitApproval,
    hasApproval,
    ccToMe,
  },
  data() {
    return {
      provide: true,
      tabIndex: 0,
    };
  },
  computed: {
    tabData() {
      return [
        {
          name: this.$t('crm_myApproval.wo_fa_qi_de'),
          value: 0
        },
        {
          name: this.$t('crm_myApproval.dai_wo_shen_pi'),
          value: 1
        },
        {
          name: this.$t('crm_myApproval.wo_yi_shen_pi'),
          value: 2
        },
        {
          name: this.$t('crm_myApproval.chao_song_wo_de'),
          value: 3
        }
      ];
    }
  },
  mounted() {

    this.getFuncView();
  }
};
</script>

<style lang="scss">
.my-approval{
  padding-left: 0 !important;

  >.container{
    padding-left: 16px;
    flex: 1;
    overflow: hidden;
  }
}
</style>
